import en from "./en.json";
import it from "./it.json";

const ticket = { en, it };

export default ticket;
